import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Select, SelectTrigger, SpinnerLoader } from "@activecollab/components";
import PropTypes from "prop-types";
import { useWebhookIntegrationsEventTypes } from "~/repository";

export const SelectEventTypes = ({ name, id, value, onChange }) => {
  const { t } = useTranslation();
  const { data, isLoading } = useWebhookIntegrationsEventTypes();

  const options = useMemo(() => {
    if (data) {
      const groups = Object.keys(data).reduce((prev, groupName) => {
        const groupOptions = data[groupName].map((option) => {
          return {
            ...option,
            id: option.name,
          };
        });
        prev.push({
          id: groupName,
          name: groupName,
          options: groupOptions,
        });
        return prev;
      }, []);

      return groups;
    }
    return [];
  }, [data]);

  const handleChange = useCallback(
    (_value) => {
      if (typeof onChange === "function") {
        onChange(_value);
      }
    },
    [onChange]
  );

  return (
    <Select
      target={
        <SelectTrigger
          id={id}
          name={name}
          className="tw-w-full tw-max-w-[360px] tw-relative"
          typographyProps={{
            color: value?.length > 0 ? "primary" : "tertiary",
          }}
        >
          {value.length === 0 ? t("All Events") : t("{{count}} Event", { count: value.length })}
          {isLoading ? (
            <SpinnerLoader
              className="tw-absolute tw-right-8 tw-top-[5px]"
              data-testid="loader"
            />
          ) : null}
        </SelectTrigger>
      }
      options={options}
      type="multiple"
      selected={value}
      className="tw-w-full"
      onChange={handleChange}
      noResultText="No results"
    />
  );
};

SelectEventTypes.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.array,
  onChange: PropTypes.func,
};
